import { LegendProps } from "~/modules/visualization/components/TimeSeriesChartV3/types";
import { VisualizationCard } from "~/modules/visualization/components/VisualizationCard";
import { LegendPosition, TimeseriesChartConfig } from "~/modules/charts/types";
import { TimeseriesChartProvider } from "./TimeseriesChartProvider";

// // // //

/**
 * Maps a legend position to the timeseries chart's legend alignment/layout.
 * The chart only supports top/bottom vertical alignment, so left/right legends
 * are anchored to the top.
 */
const LEGEND_LAYOUT: Record<
    LegendPosition,
    Pick<LegendProps, "align" | "layout" | "verticalAlign">
> = {
    top: { align: "center", layout: "horizontal", verticalAlign: "top" },
    bottom: { align: "center", layout: "horizontal", verticalAlign: "bottom" },
    left: { align: "left", layout: "vertical", verticalAlign: "top" },
    right: { align: "right", layout: "vertical", verticalAlign: "top" },
};

/**
 * TimeseriesChartRenderer
 * Renders a timeseries chart with optional group-by and interval controls.
 */
export function TimeseriesChartRenderer(props: {
    title: string;
    description: string;
    config: TimeseriesChartConfig;
}) {
    const { title, description, config } = props;

    return (
        <TimeseriesChartProvider
            title={title}
            description={description}
            config={config}
            height={400}
        >
            {({
                title,
                description,
                isLoading,
                chartEl,
                loadingEl,
                customControls,
            }) => (
                <VisualizationCard
                    title={title || "Timeseries Chart"}
                    subtitle={description}
                    watermark={isLoading ? "none" : "center-40pct"}
                    wrapperClassNameOverride=""
                    colSpans={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                        xxl: 12,
                    }}
                    customControls={customControls}
                >
                    {isLoading && <>{loadingEl}</>}
                    {!isLoading && <>{chartEl}</>}
                </VisualizationCard>
            )}
        </TimeseriesChartProvider>
    );
}
